<template>
  <div class="clientes-cliente column">
    <h3>Clientes do cliente</h3>
    <div class="row cabecalho">
      <Button v-if="podeEscrever && !novo.aberto" class="botao" layout="white-green" @click="abrirNovo">
        <i class="fa fa-plus"></i> CLIENTE DO CLIENTE
      </Button>
      <Button v-if="podeEscrever && novo.aberto" class="botao" layout="red-s" @click="novo.aberto = false">
        <i class="fa fa-times"></i> FECHAR
      </Button>
      <Button class="botao atualizar" layout="green-go" @click="carregar" :loader="carregando">ATUALIZAR</Button>
    </div>
    <form v-if="novo.aberto" class="novo row column-s" onsubmit="return false;" @submit="salvarNovo">
      <input v-model="novo.nome" type="text" class="input" placeholder="Nome do cliente do cliente" maxlength="100" required />
      <Button class="botao" layout="green-go" :loader="novo.salvando"><i class="fa fa-plus"></i> ADICIONAR</Button>
    </form>
    <Loader v-if="carregando && !carregado" layout="small" />
    <div v-else-if="!lista.length" class="vazio">Nenhum cliente do cliente cadastrado.</div>
    <ul v-else class="column list">
      <li v-for="c of lista" :key="'cc' + c.id" class="row item" :class="c.status">
        <form v-if="edicao.id === c.id" class="row grid editar" onsubmit="return false;" @submit="salvarEdicao(c)">
          <input v-model="edicao.nome" type="text" class="input" maxlength="100" required />
          <Button layout="green-go" :loader="edicao.salvando">SALVAR</Button>
          <Button layout="red-s" type="button" @click="edicao.id = null">CANCELAR</Button>
        </form>
        <template v-else>
          <div class="grid-1 id"><b>{{ c.id }}</b></div>
          <div class="grid nome">{{ c.nome }}</div>
          <div class="grid hide-s datas">
            criado em {{ c.criado_em | datetime }}<span v-if="c.alterado_em"> · alterado em {{ c.alterado_em | datetime }}</span>
          </div>
          <div class="controls row justify-end grid-4">
            <div class="grid situacao" :class="c.status == 'ativo' ? 'green' : 'red'">{{ c.status }}</div>
            <div v-if="podeEscrever" class="actions row">
              <span class="editar" title="Alterar o nome" @click="editar(c)">Editar</span>
              <span v-if="c.status == 'inativo'" class="activate" title="Voltar a oferecer na categorização" @click="ativar(c)">Ativar</span>
              <span v-if="c.status == 'ativo'" class="desativar" title="Deixar de oferecer, mantendo o cadastro" @click="desativar(c)">Desativar</span>
              <span v-if="confirmando !== c.id" class="del" title="Remover; com job vinculado, o backend desativa em vez de excluir" @click="confirmando = c.id">Remover</span>
              <template v-else>
                <span class="del confirmar" @click="remover(c)">Confirmar</span>
                <span class="cancelar" @click="confirmando = null">Cancelar</span>
              </template>
            </div>
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button";
import Loader from "@/components/Loader";

// Cadastro de clientes do cliente (sc-9885), dentro da linha expandida de cada cliente em
// Clients.vue, no molde da seção de agregados. Lista, novo, edição de nome em linha, ativar,
// desativar e remover com confirmação, recarregando a lista depois de cada ação. Os botões de
// escrita só aparecem para os grupos que o backend aceita em grava, altera, ativa e remove.
const GRUPOS_ESCRITA = ["TI", "Gestor de Operação", "Diretor de Operação"];

export default {
  name: "ClientesCliente",
  components: { Button, Loader },
  props: { cliente: { type: Number, required: true } }, // id do cliente dono do cadastro
  data() {
    return {
      lista: [],
      carregando: false,
      carregado: false,
      novo: { aberto: false, nome: "", salvando: false },
      edicao: { id: null, nome: "", salvando: false },
      confirmando: null, // id aguardando a confirmação de remoção
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    podeEscrever() {
      return GRUPOS_ESCRITA.includes(this.user.grupo);
    },
  },
  methods: {
    ...mapActions("admin", ["CLIENTE_CLIENTE_LISTA", "CLIENTE_CLIENTE_NOVO", "CLIENTE_CLIENTE_EDITAR",
      "CLIENTE_CLIENTE_ATIVAR", "CLIENTE_CLIENTE_DESATIVAR", "CLIENTE_CLIENTE_EXCLUIR"]),
    async carregar() {
      this.carregando = true;
      const r = await this.CLIENTE_CLIENTE_LISTA({ id_cliente: this.cliente });
      this.lista = r && r.status === 200 && Array.isArray(r.data) ? r.data : []; // 404 é lista vazia
      this.carregando = false;
      this.carregado = true;
    },
    abrirNovo() {
      this.novo = { aberto: true, nome: "", salvando: false };
    },
    async salvarNovo() {
      this.novo.salvando = true;
      const r = await this.CLIENTE_CLIENTE_NOVO({ id_cliente: this.cliente, nome: this.novo.nome.trim() });
      this.novo.salvando = false;
      if (!r || r.status !== 201) return; // 409 e 400: a ação já avisou; o formulário fica para corrigir
      this.novo = { aberto: false, nome: "", salvando: false };
      await this.carregar();
    },
    editar(c) {
      this.edicao = { id: c.id, nome: c.nome, salvando: false };
      this.confirmando = null;
    },
    async salvarEdicao(c) {
      this.edicao.salvando = true;
      const r = await this.CLIENTE_CLIENTE_EDITAR({ id: c.id, id_cliente: this.cliente, nome: this.edicao.nome.trim(), etag: c.etag });
      this.edicao.salvando = false;
      if (!r || (r.status !== 200 && r.status !== 412)) return;
      this.edicao.id = null; // 412: alterado por outro usuário; a ação já avisou e a lista recarrega
      await this.carregar();
    },
    ativar(c) {
      return this.acao("CLIENTE_CLIENTE_ATIVAR", c);
    },
    desativar(c) {
      return this.acao("CLIENTE_CLIENTE_DESATIVAR", c);
    },
    remover(c) {
      this.confirmando = null;
      return this.acao("CLIENTE_CLIENTE_EXCLUIR", c);
    },
    // Ação por id: em 200 recarrega. O 404 é silencioso na ação e aqui também vira recarga, porque o
    // registro pode ter sumido por outra mão.
    async acao(nome, c) {
      const r = await this[nome](c.id);
      if (r && (r.status === 200 || r.status === 404)) await this.carregar();
    },
  },
  beforeMount() {
    this.carregar();
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.clientes-cliente {
  margin-top: 5px;
  padding: 20px 10px;

  h3 {
    font-size: 20px;
    background: rgba($purple, 0.8);
    color: white;
    padding: 3px 0;
    margin: 0 24px;
    text-align: center;
  }

  .cabecalho {
    margin: 20px 30px 0;

    .botao {
      font-size: 12px;
      height: 32px;
      margin-right: 12px;
      padding: 0 14px;
    }
  }

  .novo {
    padding: 7px;
    margin: 20px;

    input {
      @media (min-width: $small) {
        margin-right: 15px;
      }
    }
  }

  .vazio {
    margin: 25px 30px 0;
    opacity: 0.8;
  }

  .list {
    margin: 20px;
    padding: 7px;

    .item {
      padding: 10px;
      background: #f1f1f1;
      border: none;
      margin-bottom: 0px;
      align-items: center;

      .datas {
        font-size: 12px;
        opacity: 0.8;
      }

      .editar.grid input {
        margin-right: 10px;
      }

      .controls {
        .situacao {
          font-weight: bold;
          text-transform: capitalize;

          &.green { color: $green-2; }
          &.red { color: $red-1; }
        }

        .actions {
          font-weight: 500;

          span {
            font-size: 13px;
            text-align: center;
            color: #fff;
            padding: 3px 10px;
            margin-left: 6px;
            border-radius: 20px;
            background: $purple;

            &.activate { background: $green-2; }
            &.desativar { background: #b58900; }
            &.del { background: $red-1; }
            &.cancelar { background: #999; }

            &:hover {
              cursor: pointer;
              box-shadow: $shadow;
            }
          }
        }
      }
    }
  }
}
</style>
